<template>
  <v-layout>
    <filtersMaster ref="filtersMaster" :select="select" :filtersdef="filtros" :options="options" @filter="filter" @loadSelectsData="loadSelectsData" />
  </v-layout>
</template>
<script>
import FiltersMaster from "@/components/datatable/Filters"; /** *******************************/
import tippy from "tippy.js";
import CombosAPI from "@/services/catalogos";
import { TIPO_IMPORT_SELECT, IACH_STATUS_SELECT } from "@/constants/operativos";

export default {
  name: "FiltersModule"
  , components: { FiltersMaster }
  , data() {
    return {
      init: true
      , view: { action: { submit: { busy: false } } }
      , select: {
        subtipo: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , estatus: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , username: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
      }
      , filtros: {
        subtipo: []
        , estatus: []
        , fecha: []
        , mailsent: []
        , username: []
      }
      , options: [
        {
          code: "subtipo"
          , name: this.$t("view.filetransaction.importer.filters.subtipo")
          , icon: "fas fa-filter"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "estatus"
          , name: this.$t("view.filetransaction.importer.filters.estatus")
          , icon: "fas fa-check"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "fecha"
          , name: this.$t("view.filetransaction.importer.filters.fecha")
          , icon: "fas fa-calendar-check"
          , type: "date"
          , selected: { ini: "", end: "" }
          , disabled: false
        }
        , {
          code: "mailsent"
          , name: this.$t("view.filetransaction.importer.filters.mailsent")
          , icon: "fas fa-envelope"
          , type: "sino"
          , selected: false
          , disabled: false
        }
        , {
          code: "username"
          , name: this.$t("view.filetransaction.importer.filters.username")
          , icon: "fas fa-user"
          , type: "select"
          , selected: {}
          , disabled: !this.$userPermission.hasPermission("ROLE_TODOS_IACH")
        }
      ]
    };
  }
  , created() {
    this.$nextTick(() => tippy(".btn_tippy_menu", { arrow: true, size: "large", animation: "scale", placement: "left" }));
  }
  , methods: {
    filter(filtros) {
      this.$emit("filter", filtros);
    }
    , async loading(status = false) {
      this.view.action.submit.busy = status;
    }
    , async loadSelectsData() {
      if (this.init) {
        this.loadSelectSubtipo();
        this.loadSelectEstatus();
        this.loadSelectUsername();

        if (this.select.subtipo.filteredList.length > 0) this.init = false;
      }
    }
    , async loadSelectSubtipo() {
      let subtipoList = [];
      if (this.$userPermission.hasPermission("ROLE_ACCESO_TIPO_IMPORT") || this.$userPermission.hasPermission("ROLE_TODOS_IACH")) subtipoList = [...subtipoList, ...TIPO_IMPORT_SELECT];
      this.select.subtipo.filteredList = subtipoList || [];
      this.select.subtipo.completeList = subtipoList || [];
    }
    , async loadSelectEstatus() {
      this.select.estatus.filteredList = IACH_STATUS_SELECT;
      this.select.estatus.completeList = IACH_STATUS_SELECT;
    }
    , async loadSelectUsername() {
      const { data: { results: { combo: usernameList } } } = await CombosAPI.get({ option: "usuariosActive" });
      this.select.username.filteredList = usernameList ? usernameList.filter((value) => value.status) : [];
      this.select.username.completeList = usernameList || [];
      this.select.username.filteredList = [...this.select.username.filteredList, { code: "auto", name: "Auto" }];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fab-container {
  position: fixed;
  top: 110px;
  right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/filetransaction/importer/Filters.vue